import React, { FC, useState } from 'react';

import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainContentWrapper,
  Title,
  Subtitle,
  LinksGrid,
  LinkItem,
  LinkText,
  SeeMoreButton,
} from './styled';
import { InterlinkSectionProps } from './types';

const INITIAL_DISPLAY_COUNT = 10;

const InterlinkSection: FC<InterlinkSectionProps> = ({
  title,
  subtitle,
  items,
  showSeeMore = false,
  seeMoreLabel = 'See more',
}) => {
  const [showAll, setShowAll] = useState(false);

  const displayedItems =
    showSeeMore && !showAll ? items.slice(0, INITIAL_DISPLAY_COUNT) : items;

  const hasMoreItems = showSeeMore && items.length > INITIAL_DISPLAY_COUNT;

  return (
    <StyledSection id="what-cryptos-can-you-buy">
      <StyledContentBlock>
        <MainContainer>
          <MainContentWrapper>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
          </MainContentWrapper>
          <LinksGrid>
            {displayedItems.map(item => (
              <LinkItem key={item.slug} href={item.url}>
                <LinkText>{item.label}</LinkText>
              </LinkItem>
            ))}
          </LinksGrid>
          {hasMoreItems && !showAll && (
            <SeeMoreButton onClick={() => setShowAll(true)}>
              {seeMoreLabel}
            </SeeMoreButton>
          )}
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default InterlinkSection;
